import { library } from '@fortawesome/fontawesome-svg-core'
import { faMagnifyingGlassPlus, faMagnifyingGlassMinus, faPhone, faEnvelope, faLink, faArrowUp, faLocationPin, faLocationDot, faTimes, faBars, faUtensils, faShip, faCamera, faLeaf, faFish, faComputerMouse, faUpRightAndDownLeftFromCenter } from '@fortawesome/free-solid-svg-icons'
import { faCirclePlay } from '@fortawesome/free-regular-svg-icons'
import { faFacebook, faTwitter, faInstagram, faYoutube, faTiktok } from '@fortawesome/free-brands-svg-icons'

library.add(
	faPhone,
	faEnvelope,
	faLink,
	faArrowUp,
	faLocationPin,
	faLocationDot,
	faTimes,
	faBars,
	faFacebook,
	faTwitter,
	faInstagram,
	faYoutube,
	faTiktok,
	faCirclePlay,
	faUtensils,
	faShip,
	faCamera,
	faLeaf,
	faFish,
	faComputerMouse,
	faUpRightAndDownLeftFromCenter,
	faMagnifyingGlassPlus,
	faMagnifyingGlassMinus
)
